import React, { useState, useEffect } from 'react';
import axios from 'axios';

export const TopProducts = () => {
  const [topProducts, setTopProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTopProducts();
  }, []);

  const loadTopProducts = async () => {
    try {
      const response = await axios.get('https://jojomarket.ne/adminfood/functionstats.php?topproduits');
      setTopProducts(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des produits:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!topProducts || topProducts.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <p className="text-muted">Aucun produit commandé récemment</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header pb-0">
        <div className="row">
          <div className="col-lg-6 col-7">
            <h6>Top 20 Produits les Plus Commandés</h6>
            <p className="text-sm text-muted mb-0">30 derniers jours</p>
          </div>
          <div className="col-lg-6 col-5 my-auto text-end">
            <button 
              className="btn btn-sm btn-outline-primary"
              onClick={loadTopProducts}
            >
              <i className="fas fa-sync-alt me-1"></i>
              Actualiser
            </button>
          </div>
        </div>
      </div>
      <div className="card-body px-0 pt-0 pb-2">
        <div className="table-responsive">
          <table className="table align-items-center mb-0">
            <thead>
              <tr>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Rang
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Produit
                </th>
                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Quantité
                </th>
                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Commandes
                </th>
                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Chiffre d'Affaires
                </th>
                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Stock
                </th>
              </tr>
            </thead>
            <tbody>
              {topProducts.map((product, index) => (
                <tr key={product.idproduit}>
                  <td className="align-middle text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      {index < 3 ? (
                        <span className={`badge badge-sm ${
                          index === 0 ? 'bg-gradient-warning' : 
                          index === 1 ? 'bg-gradient-secondary' : 
                          'bg-gradient-danger'
                        }`}>
                          {index + 1}
                        </span>
                      ) : (
                        <span className="badge badge-sm bg-gradient-light text-dark">
                          {index + 1}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="align-middle">
                    <div className="d-flex px-2 py-1">
                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">{product.nomproduit}</h6>
                        <p className="text-xs text-secondary mb-0">
                          {parseFloat(product.prix).toLocaleString('fr-FR')} FCFA
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="align-middle text-center">
                    <span className="badge badge-sm bg-gradient-primary">
                      {parseInt(product.total_commande)}
                    </span>
                  </td>
                  <td className="align-middle text-center">
                    <span className="text-xs font-weight-bold">
                      {product.nb_commandes}
                    </span>
                  </td>
                  <td className="align-middle text-center">
                    <span className="text-xs font-weight-bold text-success">
                      {parseFloat(product.chiffre_affaires_produit).toLocaleString('fr-FR')} FCFA
                    </span>
                  </td>
                  <td className="align-middle text-center">
                    <span className={`text-xs font-weight-bold ${
                      product.stock > 10 ? 'text-success' : 
                      product.stock > 0 ? 'text-warning' : 'text-danger'
                    }`}>
                      {product.stock}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TopProducts;
